import { PathkitLogo, PK_COLORS } from '../PathkitLogo';

interface FooterColumn {
  heading: string;
  links: { label: string; href: string }[];
}

const columns: FooterColumn[] = [
  {
    heading: 'Product',
    links: [
      { label: 'Features', href: '#features' },
      { label: 'Pricing', href: '#pricing' },
      { label: 'Platforms', href: '#platforms' },
      { label: 'Book a demo', href: '/book-demo' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'About', href: 'mailto:hello@pathkit.pro?subject=About%20PathKit' },
      { label: 'Customers', href: 'mailto:hello@pathkit.pro?subject=Customer%20stories' },
      { label: 'Contact', href: 'mailto:hello@pathkit.pro' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'AI Data Use', href: '/ai-trust' },
      { label: 'Terms of Service', href: '/terms' },
      { label: 'Cookies', href: '/privacy#cookies' },
      { label: 'GDPR', href: '/privacy#gdpr' },
    ],
  },
  {
    heading: 'Support',
    links: [
      { label: 'Support center', href: '/support' },
      { label: 'Email support', href: 'mailto:support@pathkit.pro' },
      { label: 'Sign in', href: '/login' },
    ],
  },
];

export function MarketingFooter() {
  const year = new Date().getFullYear();

  return (
    <footer
      className="border-t border-slate-200 bg-white"
      aria-label="Site footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-1">
            <a href="/" className="inline-flex items-center gap-2">
              <PathkitLogo className="w-7 h-7" />
              <span className="text-base font-semibold" style={{ color: PK_COLORS.navy }}>
                PathKit
              </span>
            </a>
            <p className="mt-3 text-xs text-slate-500 max-w-[18rem]">
              The single workspace for service desk consulting firms.
            </p>
          </div>

          {columns.map((col) => (
            <nav key={col.heading} aria-labelledby={`foot-${col.heading}`}>
              <h3
                id={`foot-${col.heading}`}
                className="text-xs font-semibold uppercase tracking-wide"
                style={{ color: PK_COLORS.navy }}
              >
                {col.heading}
              </h3>
              <ul className="mt-3 space-y-2">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="text-sm text-slate-600 hover:text-slate-900 transition-colors"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-slate-100 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-slate-500">
            &copy; {year} PathKit. Made for service-desk consultants.
          </p>
          <p className="text-xs text-slate-500">
            <a href="/privacy" className="hover:text-slate-700">
              Privacy
            </a>{' '}
            &middot;{' '}
            <a href="/ai-trust" className="hover:text-slate-700">
              AI Trust
            </a>{' '}
            &middot;{' '}
            <a href="/terms" className="hover:text-slate-700">
              Terms
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
